import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import ModalComponent from '../../../../components/common/ModalComponent';
import CustomLoader from "../../../../components/common/CustomLoader";
import { ADD_CELL_MODAL_TYPE } from "./ResizableTable";
import { addBusiness360ItemAPI, getDashboardData } from "../../../../service/ai-model.service";
import { DashboardViewType } from "../../../../helper/constant";
import { useAppContext } from "../../../../context/app.context";

const AddBusinessCellModal = ({ type, showModal, setShowModal, onSave, reference, businessData }) => {
    const [loading, setLoading] = useState(false);
    const [productList, setProductList] = useState([]);
    const [opportunities, setOpportunities] = useState([]);
    const [recommendations, setRecommendations] = useState([]);
    const [formData, setFormData] = useState({ product: '', opportunity: '', recommendation: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const orgNameRef = useRef(null);
    const { updateBusiness360Data, activeDashboardVersion } = useAppContext();

    useEffect(() => {
        if (showModal) {
            setErrorMessage('');
            setFormData({ product: '', opportunity: '', recommendation: '' });
            const params = new URLSearchParams(window.location.search)
            orgNameRef.current = params.get('org');
            getProducts();
        }
    }, [showModal]);

    useEffect(() => {
        if (formData.product) {
            getOpertunities(formData.product);
        }
    }, [formData.product]);

    useEffect(() => {
        if (formData.opportunity) {
            getRecommendations(formData.opportunity);
        }
    }, [formData.opportunity]);

    const getProducts = () => {
        const list = businessData?.products || [];
        setProductList(list);
    }

    const getOpertunities = (product) => {
        const opps = productList.filter((p) => p.name === product).map((p) => p.opportunities)[0];
        setOpportunities(opps || []);
    }

    const getRecommendations = (item) => {
        const rec = opportunities.filter((p) => p.content === item).map((p) => p.recommendations)[0];
        setRecommendations(rec || []);
    }

    const handleFormChange = (field, value) => {
        const data = { ...formData };
        data[field] = value;
        setFormData(data);
    }

    const renderProductList = () => {
        if (type !== ADD_CELL_MODAL_TYPE.PRODUCT)
            return (
                <div className="d-flex flex-column gap-1">
                    <label htmlFor="product-select" className="form-label">Select Product</label>
                    <div className="form-group mb-0">
                        <select className="form-control product-select"
                            id="product-select"
                            style={{ borderRadius: '50px', backgroundClip: "#F0F0F0" }}
                            value={formData.product || ''}
                            onChange={(e) => handleFormChange('product', e.target.value)}>
                            <option value="" disabled>Select Product</option>
                            {productList.map((i, index) => <option value={i.name} key={`product-index-${index}`}>{i.name}</option>)}
                        </select>
                    </div>
                </div>
            )
    }

    const renderOppertunityList = () => {
        if (type === ADD_CELL_MODAL_TYPE.RECOMMENDATION || type === ADD_CELL_MODAL_TYPE.SUB_TASK)
            return (
                <div className="d-flex flex-column gap-1">
                    <label htmlFor="product-select" className="form-label">Select Opportunitiy</label>
                    <div className="form-group mb-0">
                        <select className="form-control opportunity-select"
                            id="opportunity-select"
                            style={{ borderRadius: '50px', backgroundClip: "#F0F0F0" }}
                            value={formData[ADD_CELL_MODAL_TYPE.OPPERTUNITY] || ''}
                            onChange={(e) => handleFormChange(ADD_CELL_MODAL_TYPE.OPPERTUNITY, e.target.value)}>
                            <option value="" disabled>Select Opportunitiy</option>
                            {opportunities.map((i, index) => <option value={i.content} key={`opportunity-index-${index}`}>{i.content}</option>)}
                        </select>
                    </div>
                </div>
            )

    }

    const renderRecommendationList = () => {
        if (type === ADD_CELL_MODAL_TYPE.SUB_TASK)
            return (
                <div className="d-flex flex-column gap-1">
                    <label htmlFor="product-select" className="form-label">Select Recommendation</label>
                    <div className="form-group mb-0">
                        <select className="form-control recommendation-select"
                            id="recommendation-select"
                            style={{ borderRadius: '50px', backgroundClip: "#F0F0F0" }}
                            value={formData[ADD_CELL_MODAL_TYPE.RECOMMENDATION] || ''}
                            onChange={(e) => handleFormChange(ADD_CELL_MODAL_TYPE.RECOMMENDATION, e.target.value)}>
                            <option value="" disabled>Select Recommendation</option>
                            {recommendations.map((i, index) => <option value={i.content} key={`recommendation-index-${index}`}>{i.content}</option>)}
                        </select>
                    </div>
                </div>
            )

    }


    const renderTextArea = () => {
        if (type)
            return (
                <div className="d-flex flex-column gap-1">
                    <label htmlFor={`workflow-form-input-body`} className="capitalize bold">{type}</label>
                    <textarea
                        id={`workflow-form-input-body`}
                        type="text"
                        className={`form-control workflow-form-input`}
                        value={formData[type.toLowerCase()]}
                        placeholder={type}
                        maxLength={1000}
                        onChange={(e) => handleFormChange(type.toLowerCase(), e.target.value)}
                    />
                </div>
            )
    }

    const renderAddNewCellForm = () => {
        return (
            <div className="d-flex flex-column gap-3 w-50 mx-auto">
                {renderProductList()}
                {renderOppertunityList()}
                {renderRecommendationList()}
                {renderTextArea()}
            </div >
        )
    }


    const onSavePressed = () => {
        setLoading(true);
        const query = new URLSearchParams(window.location.search);
        const pi = productList.findIndex((p) => p.name === formData.product);
        const oi = opportunities.findIndex((p) => p.content === formData.opportunity);
        const ri = recommendations.findIndex((p) => p.content === formData.recommendation);
        const payload = {
            companyName: query.get('org') || '',
            type,
            versionId: activeDashboardVersion,
            reference: {
                products: pi,
                opportunities: oi,
                recommendations: ri,
                key: type === ADD_CELL_MODAL_TYPE.OPPERTUNITY || type === ADD_CELL_MODAL_TYPE.RECOMMENDATION ? 'content' : 'name'
            },
            content: formData[type.toLowerCase()] || '',
        };
        if (pi === -1) {
            delete payload.reference.products;
        }
        if (oi === -1) {
            delete payload.reference.opportunities;
        }
        if (ri === -1) {
            delete payload.reference.recommendations;
        }
        addBusiness360ItemAPI(payload).then((res) => {
            const param = new URLSearchParams(window.location.search);
            const org = param.get('org');
            getDashboardData({ type: DashboardViewType.DASHBOARDS, org, versionId: activeDashboardVersion })
                .then((result) => {
                    if (result && result.data) {
                        updateBusiness360Data([result.data]);
                        setShowModal(false);
                    }
                }).catch((e) => e)
                .finally(() => setLoading(false));
        }).catch((err) => {
            setErrorMessage('Error adding new cell');
            setLoading(false)
        });
    }

    const renderAction = () => {
        if (type)
            return (
                <button className={`btn btn-primary align-self-end btn-success`} type="button"
                    disabled={!formData[type.toLowerCase()]}
                    onClick={() => onSavePressed()} >
                    <span><FontAwesomeIcon icon={faSave} /></span> Save
                </button>
            )
    }

    const renderContent = () => {
        return (
            <div className="ai-generative-data d-flex flex-column gap-1">
                {renderAddNewCellForm()}
            </div>
        )

    }

    const renderLoader = () => {
        if (loading) {
            return <div className="d-flex justify-content-center"><CustomLoader /></div>
        }
        if (errorMessage) {
            return <p className="text-danger text-center">{errorMessage}</p>
        }
    }

    const render = () => {
        return (
            <>
                {loading && <CustomLoader full />}
                <ModalComponent
                    full
                    title={`Add New : ${type}`}
                    show={showModal}
                    handleClose={() => {
                        setShowModal(false);
                    }}
                >
                    <div className="d-flex flex-column gap-2">
                        {renderAction()}
                        {renderLoader()}
                        {renderContent()}
                    </div>

                </ModalComponent>
            </>
        )
    }
    return render();
}
export default AddBusinessCellModal